import BodyText from '../BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LogoutText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID, text } = props;

    return (
        <BodyText className={`${className} ${styles.logoutText}`} testId={testId}>
            {children || text}
        </BodyText>
    );
};

export default LogoutText;
